// extracted by mini-css-extract-plugin
export default {"errorContainer":"x8vsTi7f1TwcZD4RcR2n"};